// extracted by mini-css-extract-plugin
export default {"ninjaTextButton":"AO4K9KYuszs9CT3BYBBr","pending":"lGIF_htWCCY764cJw55x","block":"ZzYhB0ra4Jd9hUAMZum1","inline":"cwjnwqh2KlCZKGpFYH2u","pendingContainer":"VePIV_seB5_RBbmJEHew"};